

import logo from "../assets/logo.svg";
import { classNames } from "../helpers";


export default function BZLogo({ className, imageClassName }) {
  return (
    <img src={logo} alt="Bookzy" className={classNames("w-1/2 sm:w-2/6 md:w-auto", className)} />
  );
}
